var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { fetchFreshToken } from '../AuthHelper';
import { getHeader, header } from './restApiHeader';
import { isRoofNavEditor, isRoofNavEngineer, isRoofNavAuditor } from './userRoles';
var userValidation = function (azureADPCA, setLoading) { return __awaiter(void 0, void 0, void 0, function () { var _azureADPCA$getActive, userRole, localStorageInfo, userGuid, token, endPointUrl, inserApiUrl, _azureADPCA$getActive2, credentials, payload, tokenResponse; return __generator(this, function (_a) {
    switch (_a.label) {
        case 0:
            setLoading(true);
            userRole = localStorage.getItem('user_role');
            localStorageInfo = userRole !== null && userRole !== void 0 ? userRole : null;
            userGuid = (_azureADPCA$getActive = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive === void 0 ? void 0 : _azureADPCA$getActive.localAccountId;
            return [4 /*yield*/, fetchFreshToken()];
        case 1:
            token = _a.sent();
            endPointUrl = '/user/roles';
            inserApiUrl = '/user';
            if (!(localStorageInfo == null)) return [3 /*break*/, 3];
            return [4 /*yield*/, fetch(process.env.REACT_APP_RNDM_API_BASE_URL + endPointUrl, getHeader('get', userGuid, token)).then(function (response) { return response.json(); }).then(function (responseJson) { localStorage.setItem('user_role', responseJson.at(0)); }).catch(function (error) { return { status: 'error', response: error }; })];
        case 2:
            _a.sent();
            _a.label = 3;
        case 3:
            if (!(isRoofNavEditor() || isRoofNavEngineer() || isRoofNavAuditor())) return [3 /*break*/, 5];
            credentials = azureADPCA === null || azureADPCA === void 0 ? void 0 : (_azureADPCA$getActive2 = azureADPCA.getActiveAccount()) === null || _azureADPCA$getActive2 === void 0 ? void 0 : _azureADPCA$getActive2.idTokenClaims;
            payload = { firstName: credentials === null || credentials === void 0 ? void 0 : credentials.given_name, lastName: credentials === null || credentials === void 0 ? void 0 : credentials.family_name, email: credentials === null || credentials === void 0 ? void 0 : credentials.email, userUUID: credentials === null || credentials === void 0 ? void 0 : credentials.user_uuid };
            return [4 /*yield*/, fetch(process.env.REACT_APP_RNDM_API_BASE_URL + inserApiUrl, header('post', userGuid, token, payload)).catch(function (error) { console.log('Call to /user endpoint failed', error); return { status: 'error', response: error }; })];
        case 4:
            tokenResponse = _a.sent();
            if (tokenResponse instanceof Response && !tokenResponse.ok) {
                console.log('Call to /user endpoint failed with HTTP status code ', tokenResponse.status);
                return [2 /*return*/, false];
            }
            return [3 /*break*/, 6];
        case 5:
            localStorage.setItem('showInvalidUserRoleNotification', 'true');
            azureADPCA.logoutRedirect();
            localStorage.removeItem('user_role');
            return [2 /*return*/, false];
        case 6:
            setLoading(false);
            return [2 /*return*/, true];
    }
}); }); };
export { userValidation };
